var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 16.2C23.0029 17.1237 22.6572 18.0145 22.0317 18.6943C21.4063 19.3741 20.5474 19.7927 19.6267 19.8666C17.8055 20.0011 15.2756 20.1233 12 20.1233C8.72445 20.1233 6.19446 20.0011 4.37335 19.8666C3.45259 19.7927 2.59366 19.3741 1.96825 18.6943C1.34285 18.0145 0.997059 17.1237 1.00002 16.2V6.9111C0.997059 5.9874 1.34285 5.09661 1.96825 4.41682C2.59366 3.73703 3.45259 3.31834 4.37335 3.24444C6.19446 3.12222 8.72445 3 12 3C15.2756 3 17.8055 3.12222 19.6267 3.25667C20.5453 3.33039 21.4025 3.74736 22.0276 4.42455C22.6527 5.10175 22.9999 5.9895 23 6.9111V16.2ZM9.55556 7.88888V15.2222L15.6667 11.5555L9.55556 7.88888Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.343248a59163b2c501014e1a652db0d4.svg";
export { ForwardRef as ReactComponent };